import { render, staticRenderFns } from "./CollapseListItem.vue?vue&type=template&id=669478fe"
import script from "./CollapseListItem.vue?vue&type=script&lang=js"
export * from "./CollapseListItem.vue?vue&type=script&lang=js"
import style0 from "./CollapseListItem.vue?vue&type=style&index=0&id=669478fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports